// Public addresses opened from emails and QR codes: no guard, product header (FR-004; routes.md).
import { Slot } from "expo-router";

export default function PublicLayout() {
  return <Slot />;
}

// A screen that throws shows the themed fallback (FR-041; US6-2).
export { ErrorFallback as ErrorBoundary } from "@/shell/ErrorFallback";
